module.exports = __webpack_public_path__ + "static/media/outlined-crown.724b8373.svg";